export default __webpack_public_path__ + "static/media/logo192x192.9eaf8b58.png";